<template>
  <div class="login-tag">
    <div class="login-main is-flex is-justify-content-center is-align-items-center">
      <div class="card">
        <header class="is-size-5">
          <h3
            class="card-header-title is-uppercase has-text-dark is-justify-content-center mb-2"
          >
            {{ $t('reset password') }}
        </h3>
           <div class="is-flex is-justify-content-center mb-2">
            <img src="../assets/logo-login.svg" width="250" height="100%">
          </div>
        </header>
        <div class="card-content">
          <div class="field">
            <p class="control has-icons-right">
              <input
                class="input"
                v-model="user.newPassword"
                :placeholder="$t('Choose Password')"
                minlength="8"
                :type="password ? 'text' : 'password'"
              >
              <span
                class="icon is-small is-right is-clickable"
                @click="password = !password"
                @mouseover="
                  password
                    ? (eyeIcon = 'icon-hide')
                    : (eyeIcon = 'icon-show')
                "
                @mouseleave="
                  password
                    ? (eyeIcon = 'icon-show')
                    : (eyeIcon = 'icon-hide')
                "
              >
                <i :class="eyeIcon"></i>
              </span>
            </p>
          </div>
          <div class="field">
            <p class="control has-icons-right">
              <input
                class="input"
                :type="verifyPassword ? 'text' : 'password'"
                v-model="user.confirmPassword"
                :placeholder="$t('Verify Password')"
              >
              <span
                class="icon is-small is-right is-clickable"
                @click="verifyPassword = !verifyPassword"
                @mouseover="
                  verifyPassword
                    ? (verifyEyeIcon = 'icon-hide')
                    : (verifyEyeIcon = 'icon-show')
                "
                @mouseleave="
                  verifyPassword
                    ? (verifyEyeIcon = 'icon-show')
                    : (verifyEyeIcon = 'icon-hide')
                "
              >
                <i :class="verifyEyeIcon"></i>
              </span>
            </p>
          </div>
          <div class="is-offset-one-quarter">
          </div>
        </div>
        <footer
          class="card-footer is-justify-content-flex-end -small"
        >
        <a @click="resetPassword()" class="button login-button is-uppercase is-dark has-text-white">Reset</a>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import {
  reactive, toRefs,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Company from '@/models/Companies';
import { useToast } from 'vue-toastification';
import { DialogProgrammatic } from '@/components/Dialog';

export default {
  name: 'resetPassword',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const toast = useToast();
    const state = reactive({
      password: false,
      verifyPassword: false,
      email: '',
      key: '',
      user: {
        newPassword: '',
        confirmPassword: '',
      },
      icons: ['times-circle', 'exclamation-circle'],
      eyeIcon: 'icon-hide',
      verifyEyeIcon: 'icon-hide',

    });
    const resetPassword = async () => {
      if (state.user.newPassword !== state.user.confirmPassword || state.user.newPassword === '' || state.user.confirmPassword === '') {
        toast.error('Please match the passwords');
      } else {
        const confirmParam = {
          title: 'Warning',
          message: 'Setting this password will update the licensing password used across other ALLPLAN products, such as SDS2.',
          okButton: 'Reset',
          cancelButton: 'Cancel',
          type: 'warning',
          onConfirm: async () => {
            try {
              state.email = route.query.email;
              state.key = route.query.key;
              await Company.resetPassword({
                passwords: {
                  email: state.email,
                  key: state.key,
                  newPassword: state.user.newPassword,
                  repeatPassword: state.user.confirmPassword,
                },
              });
              toast.success('Password reset is done');
              router.push({ path: '/login' });
            } catch (e) {
              // alertMessage(e);
              if (e.data?.message) {
                toast.error(e.data.message);
              }
              console.log('error', e);
            }
          },
        };
        DialogProgrammatic.confirm(confirmParam);
      }
    };
    return {
      ...toRefs(state),
      resetPassword,
    };
  },
};
</script>

<style scoped>
.card {
  width: 432px;
  border-radius: 8px;
}
::v-deep(.eye-button) {
  position: absolute;
  right: 7px;
  top: 7px;
}
.control.has-icons-left .icon.is-left,
.control.has-icons-right .icon.is-right {
  height: 100%;
}

</style>
